import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import offer from './modules/offer'
import business from './modules/business'
import staff from './modules/staff'
import loyalty from './modules/loyalty'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    offer,
    business,
    staff,
    loyalty,
  },
  state: {
    title: '',
    authUser: {},
  },
  getters: {
  },
  mutations: {
    set (state, { type, items }) {
      state[type] = items
    },
  },
  actions: {
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js